import { EventEmitter } from '@angular/core';
import { ActiveModal } from './modal.service';

export class ModalComponent {
  closed: EventEmitter<any> = new EventEmitter<any>();
  _opened: boolean = false;

  constructor(public modal: ActiveModal) {

  }

  close() {
    this.opened = false;
  }

  set opened(o: boolean) {
    this._opened = o;

    if (!o) {
      this.modal.close();
    }
  }

  get opened() {
    return this._opened;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/modal.component.ts